import CoinDisplay from "./CoinDisplay";

import corruptionImage from "../../assets/Twitch_Corruption_112.png";

import "./TitleBar.css";
import UserInfoDisplay from "./UserInfoDisplay.js";

interface Props {
    title: string;
    children?: React.ReactNode;
}

export default function TitleBar({ title, children }: Props) {
    return (
        <div className="title-bar">
            <img className="title-icon" src={corruptionImage} />
            <span className="title-text">{title}</span>
            <span style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                {children}
            </span>
            <CoinDisplay />
            <UserInfoDisplay />
        </div>
    );
}
